import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const YandexMetrika = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (window.ym) {
      window.ym(96735625, 'hit', window.location.href);
    }
  }, [location]);
  
  return null; // Этот компонент ничего не рендерит
};